import React from 'react';

import { ModalPopup } from '../../../components/Elements/Modal';

import { ConfirmFreeTrialModal } from './ConfirmFreeTrialModal';

import { NoFreeTrialModalTitle } from './NoFreeTrialModalTitle';

import {
  noFreeTrialReportLocated,
  locateFreeTrialReport,
} from '../../../constants/Pages/FreeTrialReport';

export const NoFreeTrialReport = ({ loading, isLocateFreeTrialModalOpen, handleModalPopup }) => {
  return (
    <div className="none-free-trial-report">
      <div className="no-trial-report-located-text">{noFreeTrialReportLocated}</div>
      <ModalPopup
        buttonContent={
          <div className="locate-free-trial-report-button">{locateFreeTrialReport}</div>
        }
        modalContent={<ConfirmFreeTrialModal />}
        title={<NoFreeTrialModalTitle />}
        handleOpen={loading === false ? () => handleModalPopup(true) : () => {}}
        handleClose={() => handleModalPopup(false)}
        open={isLocateFreeTrialModalOpen}
      />
    </div>
  );
};
